<template>
  <form
    id="planning-modal-step-two"
    class="planning-modal-step-two"
    aria-labelledby="add-crossdock-instructions"
  >
    <p id="add-crossdock-instructions">
      {{ t('routeBuilder.addCrossdockInstructions', numberOfCrossdocks) }}
    </p>

    <AddCrossdockEdit
      v-for="(num, index) in numberOfCrossdocks"
      :id="`crossdock-${num}`"
      :key="num"
      :location="internalValue[index]"
      :location-label="
        () =>
          numberOfCrossdocks > 1
            ? `${t('shipments.crossdocks')} ${num}`
            : t('shipments.crossdocks')
      "
      :autofocus="index === 0"
      append-to="body"
      @update:location="onUpdateLocation($event, index)"
    />
  </form>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { useModelValue, useValidations } from '@rygen/rygen-ui/composables';
import { Location } from '@rygen/rygen-ui/model';
import { notNull } from '@rygen/rygen-ui/util';

import AddCrossdockEdit from '@/components/routeBuilder/planningPool/AddCrossdockEdit.vue';

const props = defineProps({
  modelValue: {
    type: Array as PropType<Location[]>,
    default: () => [],
  },
  numberOfCrossdocks: {
    type: Number,
    required: true,
    validator: (providedValue: number) => {
      return providedValue > 0;
    },
  },
});
const { modelValue, numberOfCrossdocks } = toRefs(props);
const emit = defineEmits<{
  (event: 'update:model-value', newVal: Location[]): void;
}>();

const { t } = useI18n();
const { internalValue } = useModelValue(modelValue, {
  emit,
  factoryMethod: (opts: Partial<Location[]>) => opts.filter(notNull),
});
const { validate } = useValidations(internalValue, {});

const onUpdateLocation = (newVal: Location, index: number) => {
  internalValue.value.splice(index, 1, newVal);
};

defineExpose({
  validate,
});
</script>

<style>
.planning-modal-step-two {
  display: flex;
  flex-direction: column;
  gap: var(--gap-1);

  #add-crossdock-instructions {
    margin-bottom: var(--sp-3);
  }
}
</style>
